import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import Money from '../../../common/money';
import CountBillsTable from './CountBillsTable';

const OpenWithBillCounts = ({
  total,
  handleSubmit,
}) => (
  <form onSubmit={handleSubmit}>
    <div className="u-ph+ u-pt+">
      <FieldArray
        name="billCounts"
        component={CountBillsTable}
      />
      <div className="c-heading-small dark-mode-white">
        Total: <Money cents={total} />
      </div>
      <div className="u-text-center u-mv">
        <button className="c-btn" type="submit">
          Open Register
        </button>
      </div>
    </div>
  </form>
);
OpenWithBillCounts.propTypes = {
  total: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
OpenWithBillCounts.defaultProps = {
  total: 0,
};

export default OpenWithBillCounts;
